export default "__VITE_ASSET__DQpPbVsQ__"